import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AuctionOffer } from '../models/auction-offer';
import { AuctionOfferService } from '../services/auction-offer.service';

export const auctionOfferResolver: ResolveFn<AuctionOffer> = async (
	route: ActivatedRouteSnapshot
) => {
	const auctionService = inject(AuctionOfferService);
	const params = <{ offerid?: string }> route.params;
	const offerIdParam = params['offerid'];
	if (offerIdParam) {
		const offerId = Number(offerIdParam);
		if (auctionService.auctionOffer.id !== offerId) {
			const auctionOffer = await firstValueFrom(auctionService.getAuctionOfferById(offerId));
			auctionService.auctionOffer = new AuctionOffer();
			Object.assign(auctionService.auctionOffer, auctionOffer);
		}
	}
	return auctionService.auctionOffer;
};
